import type { AdditionalSelectors } from '@makemydeal/dr-activities-ddj';
import { getDealRefId, getDealXgId, getPartnerCode, getPartnerDealerId } from '@makemydeal/dr-sales-checkin-store';

export const additionalSelectors: AdditionalSelectors = {
    getDealXgId: (state) => getDealXgId(state),
    getDealRefId: (state) => getDealRefId(state),
    getPartnerCode: (state) => getPartnerCode(state),
    getPartnerDealerId: (state) => getPartnerDealerId(state)
};
